module.exports = __webpack_public_path__ + "media/LP_詳細ページ.94c26ae2.mp4";